import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import TextField from "../Reusable/TextInput";
import ColorField from "../Reusable/ColorField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { RichTextEditor } from "../Reusable/RichTextEditor";
import CodeField from "../Reusable/CodeField";
const animatedComponents = makeAnimated();

const StatusForm = ({
  register,
  errors,
  statusList,
  setValue,
  watch,
  control,
}: any) => {
  const [defaultValue, setDefaultValue] = useState();
  const onChange = (value: any) => {
    setValue("next_status", value);
    setDefaultValue(value);
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("next_status"));
    }
  }, [watch("next_status")]);

  return (
    <div className={tw`px-4`}>
      <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 `}>
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <ColorField
          label={"Color"}
          register={register("color")}
          errors={errors?.charge}
        />
      </div>
      <div className={tw`mx-4 mt-4`}>
        <label htmlFor="">Can Change Status To</label>
        <Select
          value={defaultValue}
          components={animatedComponents}
          closeMenuOnSelect={false}
          options={statusList}
          onChange={onChange}
          isMulti
        />
      </div>
    </div>
  );
};

export default StatusForm;
